/**
 * Texts for Notifications page
 */
export const notificationsPageText = {
    title: 'Seneste meddelelser i appen',
    titleMeta: 'Viser seneste notifikationer i appen CamAPS FX',
    descriptionMeta: 'Her er teksten til de seneste meddelelser i appen vedrørende appopdateringer, sikkerhedsmeddelelser, brugermanualopdateringer',
    keywords: 'meddelelser' ,
    localeMeta: 'da_dk',

    heading: 'Seneste meddelelser i appen',
    subheading: '',

    header_133:'',
    body_133:'',

    header_132:'Android app opdatering (YpsoPump only) 28/10/2026',
    body_132:'Kære CamAPS FX bruger, en ny version af applikationen 1.4(195) vil være tilgængelig i løbet af de næste par dage. Vælg venligst dit foretrukne opdateringstidspunkt ved at deaktivere den automatiske opdatering for CamAPS FX i Google Play Butik. Hvis du har spørgsmål, bedes du kontakte mylife-Diabetescare Kundeservice.',

    header_131:'',
    body_131:'',

    header_130:'Opdatering påkrævet (kun YpsoPump) 20/10/2026',
    body_130:'Opdatering påkrævet! Denne version af CamAPS FX kan gå ned og genstarte oftere. Opdater venligst til den nyeste version NU via Google Play Butik. Appversion 1.4(190) udfases den 20/11/2026. Efter denne dato vil “Auto Mode” ikke længere være tilgængelig, før appen er opdateret. Insulintilførslen via din pumpe fortsætter.',

    header_129:'',
    body_129:'',

    header_128:'Opdatering af brugermanual (kun YpsoPump) 15/10/2026',
    body_128:'En opdateret version af brugermanualen er nu tilgængelig. Du kan få adgang til den fra CamAPS FX-hovedmenuen ved at vælge Hjælp efter opdatering til den nyeste appversion.',

    header_127:'iOS app opdatering (YpsoPump only) 08/10/2026',
    body_127:'Kære CamAPS FX bruger, en NY VERSION af applikationen 1.4(196) vil være tilgængelig i de næste par dage. DEAKTIVER CamAPS FX AUTOMATISKE OPDATERINGER i App Store for at vælge dit foretrukne opdateringstidspunkt. Hvis du har spørgsmål, bedes du kontakte mylife-Diabetescare kundeservice.',

    header_126:'Android app opdatering (YpsoPump only) 02/10/2026',
    body_126:'Kære CamAPS FX bruger, en ny version af applikationen 1.4(194) vil være tilgængelig i løbet af de næste par dage. Vælg venligst dit foretrukne opdateringstidspunkt ved at deaktivere den automatiske opdatering for CamAPS FX i Google Play Butik. Hvis du har spørgsmål, bedes du kontakte mylife-Diabetescare Kundeservice.',

    header_125:'',
    body_125:'',

    header_124:'',
    body_124:'',

    header_123:'',
    body_123:'',

    header_122:'',
    body_122:'',

    header_121:'Apple iOS 27 udgivelse 11/09/2026',
    body_121:'Apple vil snart frigive iOS 27. For at sikre uafbrudt brug af CamAPS FX-appen skal du kontrollere kompatibiliteten mellem smartphone og operativsystem på sensorproducentens hjemmeside FØR du opdaterer din iPhone til iOS 27. Automatiske opdateringer kan være SLÅET TIL som standard i telefonens indstillinger. Overvej venligst at slå dem FRA.',

    header_120:'',
    body_120:'',

    header_119:'Opdatering af brugermanual (kun YpsoPump) 10/09/2026',
    body_119:'En opdateret version af brugermanualen er nu tilgængelig. Du kan få adgang til den fra CamAPS FX-hovedmenuen ved at vælge Hjælp efter opdatering til den nyeste appversion.',

    header_118:'Android app opdatering (YpsoPump only) 07/09/2026',
    body_118:'Kære CamAPS FX bruger, en ny version af applikationen 1.4(193) vil være tilgængelig i løbet af de næste par dage. Vælg venligst dit foretrukne opdateringstidspunkt ved at deaktivere den automatiske opdatering for CamAPS FX i Google Play Butik. Hvis du har spørgsmål, bedes du kontakte mylife-Diabetescare Kundeservice.',

    header_117:'',
    body_117:'',

    header_116:'',
    body_116:'',

    header_115:'',
    body_115:'',

    header_114:'',
    body_114:'',

    header_113:'',
    body_113:'',

    header_112:'',
    body_112:'',

    header_111:'Deaktivering af Android-versioner under 1.4(192) (Ypsopump only) 03/08/2026',
    body_111:'Kære CamAPS FX-bruger, af hensyn til cybersikkerhed vil versioner UNDER 1.4(192) blive LUKKET den 31/08/2026. Sørg venligst for, at din app er OPDATERET til version 1.4(192) før denne dato. Hvis du har spørgsmål, bedes du kontakte mylife-Diabetescare Kundeservice.',

    header_110:'',
    body_110:'',
    body_110_link_text:'',
    body_110_end: '',
    body_110_link:'',

    header_109:'Android OS 17 udgivelse 24/06/2026',
    body_109:'Android vil snart udgive OS 17. For at sikre uafbrudt brug af CamAPS FX-appen skal du kontrollere kompatibiliteten mellem smartphone og operativsystem på sensorproducentens hjemmeside FØR du opdaterer din Android til OS 17. Automatiske opdateringer kan være SLÅET TIL som standard i telefonens indstillinger. Slå dem venligst FRA.',

    header_108:'Dexcom G7 er tilgængelig (kun Ypsopump) 23/06/2026',
    body_108:'Integrationen af Dexcom G7 CGM-systemet er nu tilgængelig! Brugere, der skifter fra Dexcom G6, kan finde en vejledning til skiftet, hjælp til fejlfinding samt en oversigt over kompatible CGM-systemer på vores hjemmeside: www.mylife-diabetescare.com.',

    header_107:'',
    body_107:'',

    header_106:'Opdatering af brugermanual (kun YpsoPump) 22/06/2026',
    body_106:'En opdateret version af brugermanualen er nu tilgængelig. Du kan få adgang til den fra CamAPS FX-hovedmenuen ved at vælge Hjælp.',

    header_105:'',
    body_105:'',

    header_104:'',
    body_104:'',

    header_103:'Android app opdatering (YpsoPump only) 12/06/2026',
    body_103:'Kære mylife CamAPS FX bruger, en ny version af applikationen 1.4(192) vil være tilgængelig i løbet af de næste par dage. Vælg venligst dit foretrukne opdateringstidspunkt ved at deaktivere den automatiske opdatering for CamAPS FX i Google Play Butik. Hvis du har spørgsmål, bedes du kontakte mylife-Diabetescare Kundeservice.',

    header_102:'',
    body_102:'',

    header_101:'',
    body_101:'',

    header_100:'',
    body_100:'',

    header_99:'',
    body_99:'',

    header_98:'Afslutning af ældre operativsystemer 22/05/2026',
    body_98:'Mens vi forbereder vores næste appopdatering, bedes du bemærke, at CamAPS FX KUN vil blive understøttet på sensor-kompatible telefoner med OS 13 eller nyere eller Apple iOS 18 eller nyere. Efter denne udgivelse vil brugere med telefoner, der kører UNDER OS 13 eller iOS 18, IKKE kunne OPDATERE eller GENINSTALLERE CamAPS FX.',

    header_97:'iOS app-opdatering 22/05/2026',
    body_97:'Kære CamAPS FX-bruger, en ny version af CamAPS FX, 1.4(195), vil være tilgængelig i løbet af de næste par dage. For selv at vælge, hvornår du vil opdatere, skal du deaktivere AUTOMATISKE OPDATERINGER i App Store. Brugere med versioner UNDER Apple iOS 18 vil IKKE kunne OPDATERE CamAPS FX til denne version. En opdateret version af brugermanualen er nu tilgængelig. Hvis du har spørgsmål, bedes du kontakte mylife-Diabetescare kundeservice.',

    header_96:'',
    body_96:'',

    header_95:'',
    body_95:'',

    header_94:'',
    body_94:'',

    header_93:'Deaktivering af iOS-versioner under 1.4(193) (kun Ypsopump) 22/04/2026',
    body_93:'Kære CamAPS FX-bruger, af cybersikkerhedsmæssige årsager vil VERSIONER UNDER 1.4(193) blive DEAKTIVERET den 30. april. Sørg venligst for, at din app er OPDATERET til version 1.4(193) inden denne dato. Hvis du har spørgsmål, bedes du kontakte mylife-Diabetescare kundeservice.',

    header_92:'Udfasning af gamle operativsystemer 21/04/2026',
    body_92:'Af hensyn til cybersikkerhed vil mylife CamAPS FX fra den 30. juni 2026 KUN blive understøttet på sensor-kompatible telefoner, der kører følgende operativsystemer: Android OS 13 og nyere samt Apple iOS 18 og nyere. Brugere af operativsystemer UNDER Android OS 13 eller Apple iOS 18 vil IKKE kunne OPDATERE eller GENINSTALLERE mylife CamAPS FX efter denne dato.',

    header_91:'',
    body_91:'',
    body_91_link_text:'',
    body_91_end: '',
    body_91_link:'',

    header_90:'',
    body_90:'',

    header_89:'Dexcom G7-opdatering (kun Ypsopump) 07/04/2026',
    body_89:'Vi nærmer os! Kompatibiliteten mellem CGM-systemet Dexcom G7 og mylife CamAPS FX vil være tilgængelig til sommer 2026. Vi vil holde jer informeret, efterhånden som lanceringen nærmer sig.',

    header_88:'',
    body_88:'',

    header_87:'Deaktivering af iOS-versioner under 1.4(193) (kun Ypsopump) 16/03/2026',
    body_87:'Kære CamAPS FX-bruger, af cybersikkerhedsmæssige årsager vil VERSIONER UNDER 1.4(193) blive DEAKTIVERET den 31. marts. Sørg venligst for, at din app er OPDATERET til version 1.4(193) inden denne dato. Hvis du har spørgsmål, bedes du kontakte mylife-Diabetescare kundeservice.',

    header_86:'',
    body_86:'',
    body_86_link_text:'',
    body_86_end: '',
    body_86_link:'',

    header_85:'',
    body_85:'',

    header_84:'',
    body_84:'',

    header_83:'',
    body_83:'',

    header_82:'Android-app-opdatering (kun Ypsopump) 02/02/2026',
    body_82:'Kære CamAPS FX-bruger, en NY VERSION af applikationen vil være tilgængelig i løbet af de næste par dage – 1.4(190). DEAKTIVÉR AUTOMATISKE OPDATERINGER af CamAPS FX i Google Play Store for selv at vælge dit foretrukne opdateringstidspunkt. Af cybersikkerhedsmæssige årsager vil VERSIONER UNDER 1.4(190) blive UDFaset den 31. marts. Hvis du har spørgsmål, bedes du kontakte mylife-Diabetescare kundeservice.',

    header_81:'',
    body_81:'',

    header_80:'',
    body_80:'',

    header_79:'',
    body_79:'',

    header_78:'',
    body_78:'',

    header_77:'',
    body_77:'',

    header_76:'',
    body_76:'',

    header_75:'',
    body_75:'',

    header_74:'Besked fra mylife-Diabetescare (kun YpsoPump) 09/12/2025',
    body_74:'Du kan genopfylde dit mylife YpsoPump Reservoir én gang inden for 7 dage efter den første fyldning. Læs mere på Reservoir-siden på mylife-diabetescare-webstedet.',

    header_73:'',
    body_73:'',
    body_73_link_text:'',
    body_73_end: '',
    body_73_link:'',

    header_72:'',
    body_72:'',
    body_72_link_text:'',
    body_72_end: '',
    body_72_link:'',

    header_71:'',
    body_71:'',
    body_71_link_text:'',
    body_71_end: '',
    body_71_link:'',

    header_70:'Vigtig sikkerhedsinformation om din FreeStyle Libre 3-systemsensor 25/11/2025',
    body_70:'Abbott har identificeret, at nogle FreeStyle Libre 3- og FreeStyle Libre 3 Plus-sensorer kan vise falsk lave glukosemålinger. Gå til',
    body_70_link_text:'www.FreeStyleCheck.com',
    body_70_end: 'for at tjekke, om din aktuelle eller ubrugte sensor(er) er potentielt berørt. Hvis dine sensormålinger ikke stemmer overens med dine symptomer eller forventninger, skal du slå Auto-tilstand fra og bruge et blodsukkerapparat til at træffe behandlingsbeslutninger. Hvis du har spørgsmål eller skal rapportere problemer med din FreeStyle Libre 3-systemsensor, kontakt Abbott Kundeservice på 39 77 01 90. Het serienummer van uw huidige sensor vindt u in het app-menu in het gedeelte Sensor.',
    body_70_link:'https://www.FreeStyleCheck.com',

    header_69:'iOS-app-opdatering (kun YpsoPump) 25/11/2025',
    body_69:'Kære mylife CamAPS FX-bruger, en NY VERSION af applikationen vil være tilgængelig i de kommende dage. DEAKTIVER CamAPS FX AUTOMATISK OPDATERINGER i App Store for at vælge dit foretrukne opdateringstidspunkt. Din nuværende version vil blive UDSAT den 9. december 2025. Hvis du har spørgsmål, bedes du kontakte Ypsomed Kundeservice.',

    header_68:'',
    body_68:'',

    header_67:'',
    body_67:'',

    header_66:'',
    body_66:'',
    body_66_link_text:'',
    body_66_end: '',
    body_66_link:'',

    header_65:'',
    body_65:'',
    body_65_link_text:'',
    body_65_end: '',
    body_65_link:'',

    header_64:'',
    body_64:'',
    body_64_link_text:'',
    body_64_end: '',
    body_64_link:'',

    header_63:'',
    body_63:'',
    body_63_link_text:'',
    body_63_end: '',
    body_63_link:'',
	
    header_62:'VIGTIG PRODUKTINFORMATION 28/10/2025',
    body_62:'Læs venligst og bekræft læsningen af vigtig meddelelse',
    body_62_link_text:'N-0125',
    body_62_end: '. Gå til appmenu -> Sikkerhedsmeddelelser.',
    body_62_link:'https://s3.eu-west-1.amazonaws.com/camaps.safety.notices/Field+Safety+Notice+ET8374+Mylife+Users+DK+final.pdf',

    header_61:'iOS app opdatering (kun YpsoPump) 02/10/2025',
    body_61:'For optimal app-ydeevne, opdater venligst din mylife CamAPS FX til den NYESTE VERSION (1.4(192)) via Apple App Store.',

    header_60:'',
    body_60:'',

    header_59:'iOS app opdatering (kun YpsoPump) 22/09/2025',
    body_59:'Kære mylife CamAPS FX bruger, en NY VERSION af applikationen vil være tilgængelig i de næste par dage. DEAKTIVER CamAPS FX AUTOMATISKE OPDATERINGER i App Store for at vælge dit foretrukne opdateringstidspunkt. En ny version af brugermanualen vil være tilgængelig. Hvis du har spørgsmål, bedes du kontakte Ypsomed kundeservice.',

    header_58:'iOS 26 udgivelse (kun YpsoPump) 13/09/2025',
    body_58:'Apple vil snart udgive iOS 26. For at sikre uafbrudt brug af mylife CamAPS FX-applikationen, bedes du kontrollere sensorproducentens hjemmeside for at bekræfte smartphone- og operativsystemkompatibilitet, før du opdaterer din iPhone til iOS 26. Bemærk: Automatiske opdateringer kan være aktiveret som standard i din phones indstillinger, så husk at slå dem fra.',

    header_57:'Android app opdatering (kun YpsoPump) 26/08/2025',
    body_57:'Kære mylife CamAPS FX bruger, en ny version af applikationen vil være tilgængelig inden for de næste 2 til 3 dage. Vælg venligst dit foretrukne opdateringstidspunkt ved at deaktivere den automatiske opdatering for CamAPS FX i Google Play Butik. En ny version af brugermanualen vil være tilgængelig. Hvis du har spørgsmål, bedes du kontakte Ypsomed Kundeservice.',

    header_56:'',
    body_56:'',

    header_55:'',
    body_55:'',

    header_54:'',
    body_54:'',

    header_53:'',
    body_53:'',
	
    header_52:'',
    body_52:'',
	
    header_51:'',
    body_51:'',

    header_50:'',
    body_50:'',

    header_49:'Afbrydelse af gamle appversioner 01/07/2025',
    body_49:'Opdater venligst din app til den nyeste version, der er tilgængelig på Google Play. Den nuværende version vil stoppe med at fungere den 1. august 2025.',

    header_48:'OS 10 & 11 25/06/2025',
    body_48:'Af sikkerhedsmæssige årsager vil mylife CamAPS FX fra den 1. august 2025 kun blive understøttet på sensor-kompatible telefoner med Android-operativsystemer 12 og derover. Brugere af operativsystemer under OS 12 vil ikke længere kunne opdatere eller geninstallere mylife CamAPS FX efter denne dato.',

    header_47:'',
    body_47:'',

    header_46:'iOS-opdatering 09/06/2025',
    body_46:'En ny app-version vil være tilgængelig inden for de næste par dage. Deaktiver de automatiske app-opdateringer for at vælge dit foretrukne opdateringstidspunkt. Hvis du har spørgsmål, bedes du kontakte Ypsomeds kundeservice.',

    header_45:'Android OS 16 09/06/2025',
    body_45:'For at sikre uafbrudt brug af mylife CamAPS FX-applikationen, bedes du kontrollere producentens sensorwebside for at verificere kompatibiliteten, inden du opdaterer til Android OS 16. Bemærk: Automatiske opdateringer kan være aktiveret som standard i din telefons indstillinger.',
	
    header_44:'iOS-udgivelse (kun YpsoPump) 20/05/2025',
    body_44:'mylife CamAPS FX-appen er nu også tilgængelig til iPhones! Hvis du overvejer at skifte til iOS, skal du besøge afsnittet »Vigtig information til iOS-brugere« på www.mylife-diabetescare.com/da-DK/mylife-loop.html. En opdateret version af brugervejledningen er tilgængelig.',

    header_43:'',
    body_43:'',

    header_42:'',
    body_42:'',

    header_41:'',
    body_41:'',

    header_40:'Ny opdatering (18/03/2025)',
    body_40:'Kære mylife CamAPS FX-bruger, En ny app-version vil være klar inden for de næste 24 timer. For at vælge din foretrukne opdateringstid skal du deaktivere automatisk opdatering for CamAPS FX i Google Play Butik. Hvis du har spørgsmål, kontakt venligst Ypsomeds kundeservice.',

    header_39:'',
    body_39:'',

    header_38:'',
    body_38:'',

    header_37:'Afslutning af gammel app-version (kun Ypsopump)',
    body_37:'Den nuværende version holder op med at virke den 7. februar 2025. Opdater din app til den nyeste version, der er tilgængelig på Google Play.',

    header_36:'En ny app-version 06/01/2025',
    body_36:'Kære mylife CamAPS FX-bruger, En ny app-version vil være klar inden for de næste 48 timer. For at vælge din foretrukne opdateringstid skal du deaktivere automatisk opdatering for CamAPS FX i Google Play Butik. Hvis du har spørgsmål, kontakt venligst Ypsomeds kundeservice.',
	
	header_35:'OS 8 & 9 29/12/2024',
    body_35:'Af sikkerhedsmæssige årsager vil mylife CamAPS FX fra den 1. januar 2025 kun blive understøttet på sensor-kompatible telefoner med Android-operativsystemer 10 og derover. Brugere af operativsystemer under OS 10 vil ikke længere kunne opdatere eller geninstallere mylife CamAPS FX efter denne dato. Påmindelse, systemet er endnu ikke kompatibelt med OS15',
	
	header_34:'',
    body_34:'',
	
	header_33:'Besked om planlagt vedligeholdelse 05/12/2024',
    body_33:'På grund af planlagt vedligeholdelse af CamAPS FX Service cloud, vil Companion-funktionen ikke være tilgængelig den 7. december fra kl. 10:00 GMT i cirka tre timer. Vi undskylder for eventuelle ulemper, dette måtte medføre.',
	
	header_32:'Brugermanual opdatering 28/11/2024',
    body_32:'En opdateret version af brugervejledningen er tilgængelig.',
	
	header_31:'En ny app-version 17/11/2024',
    body_31:'Kære mylife CamAPS FX-bruger, En ny app-version vil være klar inden for de næste 48 timer. For at vælge din foretrukne opdateringstid skal du deaktivere automatisk opdatering for CamAPS FX i Google Play Butik. Hvis du har spørgsmål, kontakt venligst Ypsomeds kundeservice.',
	
	header_30:'OS 8 & 9 11/10/2024',
    body_30:'Af sikkerhedsmæssige årsager vil mylife CamAPS FX fra den 1. januar 2025 kun blive understøttet på sensor-kompatible telefoner med Android-operativsystemer 10 og derover. Brugere af operativsystemer under OS 10 vil ikke længere kunne opdatere eller geninstallere mylife CamAPS FX efter denne dato.',
	
	header_29:'En ny app-version 09/10/2024',
    body_29:'Kære mylife CamAPS FX-bruger, En ny app-version vil være klar inden for de næste 48 timer. For at vælge din foretrukne opdateringstid skal du deaktivere automatisk opdatering for CamAPS FX i Google Play Butik. Hvis du har spørgsmål, kontakt venligst Ypsomeds kundeservice.',
	
	header_28:'OS 8 & 9 08/07/2024',
    body_28:'Af sikkerhedsmæssige årsager vil mylife CamAPS FX fra den 1. januar 2025 kun blive understøttet på sensor-kompatible telefoner med Android-operativsystemer 10 og derover. Brugere af operativsystemer under OS 10 vil ikke længere kunne opdatere eller geninstallere mylife CamAPS FX efter denne dato.',
	
	header_27:'',
    body_27:'',
	
	header_26:'Brugermanual opdatering 11/05/2024',
    body_26:'En opdateret version af brugervejledningen er tilgængelig.',
	
	header_25:'',
    body_25:'',
	
	header_24:'',
    body_24:'',
	
	header_23:'En ny app-version 24/04/2024',
    body_23:'Kære mylife CamAPS FX-bruger, En ny app-version vil være klar inden for de næste 24 timer. For at vælge din foretrukne opdateringstid skal du deaktivere automatisk opdatering for CamAPS FX i Google Play Butik. Hvis du har spørgsmål, kontakt venligst Ypsomeds kundeservice.',
	
	header_22:'Brugermanual opdatering 21/04/2024',
    body_22:'En opdateret version af brugervejledningen er tilgængelig.',
	
	header_21:'',
    body_21:'',
	
	header_20:'',
    body_20:'',

	header_19:'',
    body_19:'',

    header_18:'',
    body_18:'',

    header_17:'',
    body_17:'',

	header_16:'Brugermanual opdatering 04/03/2024',
    body_16:'En opdateret version af brugervejledningen er tilgængelig.',
	
	header_15:'Brugermanual opdatering 04/01/2024',
    body_15:'En opdateret version af brugervejledningen er tilgængelig.',
	
	header_14:'Android OS 14. 22/11/2023',
    body_14:'Påmindelse: For at sikre uafbrudt brug af mylife CamAPS FX-applikationen, bedes du kontrollere producentens sensorwebside for at verificere kompatibiliteten, inden du opdaterer til Android OS 14. Bemærk: Automatiske opdateringer kan være aktiveret som standard i din telefons indstillinger.',
	
	header_13:'VIGTIG PRODUKTINFORMATION  14/11/2023',
    body_13:'VIGTIG PRODUKTINFORMATION',
    body_13_link_text:'Læs venligst og bekræft læsningen af vigtig meddelelse',
    body_13_end: '. Gå til appmenu -> Sikkerhedsmeddelelser.',
    body_13_link:'https://s3.eu-west-1.amazonaws.com/camaps.safety.notices/Field+Safety+Notice+ET5604+Mylife+Users+final+-+DK+v2.pdf',

	header_12:'Brugermanual opdatering 10/11/2023',
    body_12:'En opdateret version af brugervejledningen er tilgængelig.',
	
	header_11:'Android OS 14. 12/09/2023',
    body_11:'For at sikre uafbrudt brug af mylife CamAPS FX-applikationen, bedes du kontrollere producentens sensorwebside for at verificere kompatibiliteten, inden du opdaterer til Android OS 14. Bemærk: Automatiske opdateringer kan være aktiveret som standard i din telefons indstillinger.Sørg for, at du kører mylife CamAPS FX app version 1.4(173), før du opdaterer til Android OS 14.',
	
	header_10:'VIGTIG PRODUKTINFORMATION  15/08/2023',
    body_10:'VIGTIG PRODUKTINFORMATION Læs venligst og bekræft læsningen af vigtig meddelelse. Gå til appmenu -> Sikkerhedsmeddelelser.',

	header_9:'Brugermanual opdatering 27/07/2023',
    body_9:'En opdateret version af brugervejledningen er tilgængelig.',

	header_8:'Glooko Kompatibilitet 21/07/2023',
    body_8:'Som tidligere annonceret vil diasend blive afbrudt den 28. juli. Hvis du ønsker at fortsætte med at dele data med dit diabetes-team, bedes du opgradere din diasend-konto til Glooko eller oprette en ny Glooko-konto. Opdater til den nyeste mylife CamAPS FX-version, indtast dit nye Glooko-brugernavn og adgangskode i delingsmenuen og genstart din smartphone. Diasend vil fortsat være tilgængelig til visning af historiske data resten af året',
	
	header_7:'Samsung A-serien 14/07/2023',
    body_7:'Brugere af Samsung A-serien modeller (f.eks. A53, A33) kan have oplevet signaltab til deres CGM-sensor efter den seneste Samsung One UI 5.1-opdatering. Samsung har identificeret problemet, og en løsning er under udvikling. Samsung planlægger at frigive en opdatering til One UI den 24. juli (afhængigt af dit område), som vil løse problemet med signaltab. Det anbefales at installere opdateringen, så snart den bliver tilgængelig. Hvis du endnu ikke har opdateret til One UI 5.1, anbefaler vi at vente på den næste Samsung One UI-opdateringen.',

    header_6:'Glooko Kompatibilitet (Ypsomed) 14/06/2023',
    body_6:'mylife CamAPS FX er kompatibel med Glooko. Opdater venligst din mylife CamAPS FX-app til version 1.4(172). Hvis du deler data med en klinik, vil du blive underrettet via din eksisterende diasend-konto, når din klinik opgraderer til Glooko. Når opgraderingen er fuldført, indtast dit nye Glooko-brugernavn og adgangskode i delingsmenuen og genstart din smartphone. Opgrader venligst til Glooko inden den 28. juli 2023. Diasend vil være tilgængelig til at se historiske data resten af året.',

    header_5:'',
    body_5:'',

    header_4:'Brugermanual opdatering 27/05/2023',
    body_4:'En opdateret version af brugervejledningen er tilgængelig.',

    header_3:'SMS-advarsler (Kun Ypsopump) 11/05/2023',
    body_3:'Med den kommende opdatering 1.4(171) i midten af maj vil du kunne aktivere op til 5 SMS-følgere OG samtidig bruge Companion-tilstand. For at bruge Companion-tilstand skal brugerens telefon have en internetforbindelse til at dele data. Brugere skal have et SIM-kort for at tillade, at SMS kan sendes fra deres telefon. Hvis du bruger en af disse muligheder, anbefaler vi, at du kontrollerer, om din mobil abonnement inkluderer SMS og/eller har datadækning afhængigt af den anvendte mulighed.',

    header_2:'Cybersikkerhedsopdatering (Kun Ypsopump) 24/04/2023',
    body_2:'Sikkerheden i mylife CamAPS FX-appen er af største vigtighed. Fra midten af maj vil der være en Google Play Store-forceret cybersikkerhedsopdatering. Efter denne opdatering kan en lille del af telefonerne muligvis ikke klare sig i forbindelse med kontrollen af cybersikkerhedsintegritet. Du kan teste din telefon på forhånd ved at gå til hjælpemenuen og udfylde kontrollen. Hvis din telefon ikke består denne kontrol, kan du prøve at afinstallere og geninstallere appen.',

    header_1:'',
    body_1:'',
};
